// TODO: a forked version of a d-home idle util urgent pattern,
//       which d-hoem went through SETI winner. Next patch of the new major can
//       can refactor.
// https://bitbucket.corp.priceline.com/projects/SITE/repos/d-home/browse/src/common/utils/idle-until-urgent.js

// TODO: also tried out lib level w. below, but .mjs w. node support is in
//       experimental stage, even w. the latest stable version.
// https://github.com/GoogleChromeLabs/idlize/blob/master/docs/IdleQueue.md
// https://philipwalton.com/articles/idle-until-urgent/
let tasks = []
let isListening = false

// TODO: next refactoring at v5.0.1 will include test code per "istanbul ignore
//       next" comments.

/* istanbul ignore next */
export const idleEnqueue = (funcs) => {
  if (Array.isArray(funcs)) {
    tasks = [...funcs, ...tasks]
  } else if (typeof funcs === 'function') {
    tasks.push(funcs)
  } else {
    console.warn(`${typeof funcs} is not a supported type`)
    return false
  }

  if (!isListening) {
    addListeners()
  }
  idleUntilUrgent()
}

/* istanbul ignore next */
const addListeners = () => {
  if (typeof window !== 'undefined' && !isListening) {
    // eslint-disable-next-line no-undef
    const isSafari = !!(typeof safari === 'object' && safari.pushNotification)
    window.addEventListener('visibilitychange', runUrgentTasksImmediately, true)

    // Safari does not reliably fire the `pagehide` or `visibilitychange`
    // events when closing a tab, so we have to use `beforeunload` with a
    // timeout to check whether the default action was prevented.
    // - https://bugs.webkit.org/show_bug.cgi?id=151610
    // - https://bugs.webkit.org/show_bug.cgi?id=151234
    // NOTE: we only add this to Safari because adding it to Firefox would
    // prevent the page from being eligible for bfcache.
    if (isSafari) {
      window.addEventListener('beforeunload', runUrgentTasksImmediately, true)
    }

    isListening = true
  }
}

/* istanbul ignore next */
const removeListeners = () => {
  if (typeof window !== 'undefined' && !isListening) {
    // eslint-disable-next-line no-undef
    const isSafari = !!(typeof safari === 'object' && safari.pushNotification)
    window.removeEventListener('visibilitychange', runUrgentTasksImmediately, true)

    if (isSafari) {
      window.removeEventListener('beforeunload', runUrgentTasksImmediately, true)
    }
    isListening = false
  }
}

/* istanbul ignore next */
const idleDequeue = () => {
  if (!tasks.length) {
    removeListeners()
    return false
  }

  return tasks.shift()
}

/* istanbul ignore next */
const idleCallback = () => {
  const func = idleDequeue()
  if (func) {
    func()
    idleUntilUrgent()
  }
  return false
}

/* istanbul ignore next */
const runUrgentTasksImmediately = () => {
  while (tasks.length) {
    const task = tasks.shift()
    task()
  }
}

/* istanbul ignore next */
export const idleUntilUrgent = () => {
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(idleCallback, { timeout: 2000 })
  } else if (typeof window !== 'undefined') {
    ;(function (callback = idleCallback) {
      if (callback) {
        return setTimeout(function () {
          callback()
        }, 1)
      }
    })()
  }
}
